import { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { setAlert } from '../../actions/alert';
import { informacionCliente, editarCliente, limpiarCliente } from '../../actions/clientes';

const EditarCliente = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Clientes',
            path: '/clientes'
        },
        {
            activo: true,
            nombre: 'Editar cliente',
            path: '/clientes/editar'
        }
    ];

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { id } = useParams();

    const { detalles } = useSelector(state => state.clientes);

    const [clienteData, setClienteData] = useState({
        id: null,
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        nacimiento: null,
        celular: null,
        email: null
    });

    /* Editar cliente */
    const handleInputChange = ({ target }) => {
        setClienteData({
            ...clienteData,
            [target.name]: target.value
        });
    }

    const handleDatePicker = (name, value) => {
        setClienteData({
            ...clienteData,
            [name]: value
        });
    }

    const handleEditarCliente = async () => {
        if(clienteData.nombre){
            await dispatch(editarCliente(clienteData));

            await navigate("/clientes");
        }else{
            await dispatch(setAlert('Todos los campos son obligatorios', 'danger'));
        }
    }

    useEffect(() => {
        dispatch(limpiarCliente());

        return () => {
            dispatch(limpiarCliente());
        }
    }, []);

    useEffect(() => {
        dispatch(informacionCliente(id));

        if(id){
            rutasBread[1].path = rutasBread[1].path + id;

            dispatch(editarBreadcrumb(rutasBread));
        }
    }, [id]);

    useEffect(() => {
        setClienteData({
            ...clienteData,
            id: detalles?._id,
            nombre: detalles?.nombre,
            apellido_paterno: detalles?.apellido_paterno,
            apellido_materno: detalles?.apellido_materno,
            nacimiento: detalles?.nacimiento,
            celular: detalles?.celular,
            email: detalles?.email
        });
    }, [detalles]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Editar cliente</h3>
                
                    <div className="row">
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={clienteData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Apellido paterno" id="apellido_paterno" name="apellido_paterno" value={clienteData.apellido_paterno} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="apellido_paterno">Apellido paterno</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Apellido materno" id="apellido_materno" name="apellido_materno" value={clienteData.apellido_materno} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="apellido_materno">Apellido materno</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <DatePicker
                                        id="nacimiento"
                                        name="nacimiento"
                                        className="form-control text-center input-datepícker"
                                        dateFormat="dd/MM/yyyy"
                                        locale="es-ES"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        selected={ clienteData.nacimiento != null ? new Date(clienteData.nacimiento) : '' }
                                        onChange={ date => handleDatePicker('nacimiento', date) }
                                    />
                                    <label className="label-datepicker" htmlFor="nacimiento">Fecha de nacimiento</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Teléfono" id="celular" name="celular" value={clienteData.celular} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="celular">Teléfono</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Correo" id="email" name="email" value={clienteData.email} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="email">Correo</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12 mt-4">
                            <button className="btn btn-success float-end" onClick={handleEditarCliente}>Guardar</button>
                            <Link to='/clientes'><button className="btn btn-danger float-end me-2">Cancelar</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default EditarCliente;